import Image from "next/image";
import NumberIncreaseAnimation from "./NumberIncreaseAnimation";
import BuyNowBtn from "../button/BuyNowBtn";

function PetTagReunion({ onClick }) {
  return (
    <section className="max-w-[1440px] mx-auto py-[1.125rem] px-4 overflow-hidden">
      <div className="flex flex-col md:flex-row-reverse gap-[1rem]  md:justify-center md:items-center text-pet-tag">
        <div className="relative w-[350px] h-[440px] lg:w-[588px] lg:h-[732px]">
          <Image
            src="/assets/pet-tag/reunion.png"
            fill
            quality={40}
            alt="Reunion"
            priority
            className="object-contain scale-125"
          />
        </div>

        <div className="">
          <p className="mb-[1rem]">
            <NumberIncreaseAnimation />
            <span className="text-[4.375rem] lg:text-[5.625rem] font-extrabold leading-none">
              %
            </span>
            <br />
            <span className="text-[2.25rem] lg:text-[3rem] font-bold leading-[110%]">
              Higher Chance
            </span>
            <br />
            <span className="text-[2.25rem] lg:text-[3rem] font-bold leading-[110%]">
              of a Reunion
            </span>
          </p>
          <p className="text-[1rem] lg:text-[1.25rem] mb-[1rem] leading-[25.6px] lg:leading-[2rem] max-w-[382px] lg:max-w-[490px] ">
            Our intelligent pet tag dramatically increases the likelihood of a
            happy reunion if your pet ever goes missing. Don’t leave their
            safety to chance.
          </p>

          <BuyNowBtn onClick={onClick} />
        </div>
      </div>
    </section>
  );
}

export default PetTagReunion;
